// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Search-Row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1rem;
  padding: 31px;
  border-radius: 49px;
  background: #fff;
}
@media screen and (max-width: 767px) {
  .Search-Row {
    text-align: center;
  }
}
.Search-Row > div:last-child {
  text-align: right;
}

.Border-Light {
  margin: 0;
  border: 0;
  border-bottom: 1px solid #00ff7f;
  border-radius: 0;
}

.Search-Row-Header {
  align-items: flex-end;
  padding-top: 17px;
  padding-bottom: 17px;
  font-weight: 700;
  font-size: 18px;
  line-height: 1.33;
}

.Search-Row-Table {
  align-items: flex-start;
  font-size: 18px;
}

.Search-Row-Header,
.Search-Row-Table {
  text-align: left;
}
@media (max-width: 1199.98px) {
  .Search-Row-Header,
  .Search-Row-Table {
    padding-right: 0;
    padding-left: 0;
  }
}
.Search-Row-Header .col,
.Search-Row-Table .col {
  display: flex;
  align-items: center;
}
.Search-Row-Header .Col--name,
.Search-Row-Header .Col--address,
.Search-Row-Table .Col--name,
.Search-Row-Table .Col--address {
  display: block;
  flex: 1 1;
  max-width: initial;
}
@media (max-width: 767.98px) {
  .Search-Row-Header .Col--address,
  .Search-Row-Table .Col--address {
    display: none;
  }
}
@media (max-width: 1199.98px) {
  .Search-Row-Header .Col--name,
  .Search-Row-Table .Col--name {
    padding-left: 0;
  }
}
.Search-Row-Header .Col--reg,
.Search-Row-Table .Col--reg {
  flex: 0 0 140px;
}
@media (max-width: 767.98px) {
  .Search-Row-Header .Col--reg,
  .Search-Row-Table .Col--reg {
    flex: 0 0 80px;
    padding: 0;
    text-align: center;
    white-space: normal;
  }
}
.Search-Row-Header .Col--cta,
.Search-Row-Table .Col--cta {
  flex: 0 0 60px;
  justify-content: flex-end;
  color: #00a4ff;
  font-size: 24px;
}
@media (max-width: 767.98px) {
  .Search-Row-Header .Col--cta,
  .Search-Row-Table .Col--cta {
    display: none;
  }
}

.Search-Row-Top {
  background: #00a4ff;
  color: #fff;
}
@media (max-width: 1199.98px) {
  .Search-Row-Top {
    padding-right: 11px;
    padding-left: 11px;
  }
}
@media (max-width: 991.98px) {
  .Search-Row-Top .Col--cta {
    display: none;
  }
}

.Pagination-Container {
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;
}
.Pagination-Container :nth-child(2) {
  margin-left: 1rem;
}
.Pagination-Container :nth-last-child(2) {
  margin-right: 1rem;
}

.Search-Heading {
  margin-top: 64px;
  font-weight: 100;
  font-size: 3.125rem;
}

.Row-Margin {
  margin: 16px 0 32px;
}
@media screen and (max-width: 800px) {
  .Row-Margin {
    margin: 32px 0 48px;
  }
}
@media screen and (min-width: 1824px) {
  .Row-Margin {
    margin: 32px 0 48px;
  }
}

.Lighter-ColorText {
  color: #2b2b2b;
}

.pagination {
  flex-wrap: wrap;
}
.pagination li.previous, .pagination li.next {
  margin: 10px;
}
.pagination li.previous a, .pagination li.next a {
  padding: 4px 32px;
  font-weight: 700;
  font-size: 24px;
  line-height: 1.5;
}
@media screen and (max-width: 800px) {
  .pagination li.previous, .pagination li.next {
    width: 100%;
  }
}

.Pagination-Item {
  margin: 10px;
  color: #00a4ff;
  font-weight: 700;
}
.Pagination-Item a::after {
  content: ".";
}
.Pagination-Item.active {
  color: #003825;
}

.resultsHeading {
  margin-top: 80px;
}`, "",{"version":3,"sources":["webpack://./src/pages/SearchList.scss","webpack://./src/assets/scss/helpers/_variable.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBCEM;ADHR;AAGE;EARF;IASI,kBAAA;EAAF;AACF;AAGI;EACE,iBAAA;AADN;;AAMA;EACE,SAAA;EACA,SAAA;EACA,gCAAA;EACA,gBAAA;AAHF;;AAMA;EACE,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAHF;;AAMA;EACE,uBAAA;EACA,eAAA;AAHF;;AAMA;;EAEE,gBAAA;AAHF;AEgCI;EF/BJ;;IAKI,gBAAA;IACA,eAAA;EADF;AACF;AAGE;;EACE,aAAA;EACA,mBAAA;AAAJ;AAGE;;;;EAEE,cAAA;EACA,SAAA;EACA,kBAAA;AACJ;AEYI;EFVF;;IAEI,aAAA;EACJ;AACF;AEMI;EFJF;;IAEI,eAAA;EACJ;AACF;AAEE;;EACE,eAAA;AACJ;AEJI;EFEF;;IAII,cAAA;IACA,UAAA;IACA,kBAAA;IACA,mBAAA;EAGJ;AACF;AAAE;;EACE,cAAA;EACA,yBAAA;EACA,cC5DO;ED6DP,eAAA;AAGJ;AEpBI;EFaF;;IAOI,aAAA;EAKJ;AACF;;AADA;EACE,mBCtES;EDuET,WC1FM;AD8FR;AE/BI;EFyBJ;IAKI,mBAAA;IACA,kBAAA;EAKF;AACF;AErCI;EFkCA;IACE,aAAA;EAMJ;AACF;;AAiBA;EACE,mBAAA;EACA,uBAAA;EACA,mBAAA;AAdF;AAeE;EACE,iBAAA;AAbJ;AAeE;EACE,kBAAA;AAbJ;;AAiBA;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;AAdF;;AAkBA;EACE,mBAAA;AAfF;AAgBE;EAFF;IAGI,mBAAA;EAbF;AACF;AAcE;EALF;IAMI,mBAAA;EAXF;AACF;;AAcA;EACE,cC9IqB;ADmIvB;;AAeA;EACE,eAAA;AAZF;AAeI;EAEE,YAAA;AAdN;AAgBM;EACE,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAdR;AAiBM;EAXF;IAYI,WAAA;EAdN;AACF;;AAmBA;EACE,YAAA;EACA,cCjKS;EDkKT,gBAAA;AAhBF;AAmBI;EACE,YAAA;AAjBN;AAqBE;EACE,cC7Ka;AD0JjB;;AAwBA;EACE,gBAAA;AArBF","sourcesContent":["@import '../assets/scss/helpers/component';\n\n.Search-Row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: 1rem;\n  padding: 31px;\n  border-radius: 49px;\n  background: $white;\n\n  @media screen and (max-width: 767px) {\n    text-align: center;\n  }\n\n  > div {\n    &:last-child {\n      text-align: right;\n    }\n  }\n}\n\n.Border-Light {\n  margin: 0;\n  border: 0;\n  border-bottom: 1px solid $gbp-electric-green;\n  border-radius: 0;\n}\n\n.Search-Row-Header {\n  align-items: flex-end;\n  padding-top: 17px;\n  padding-bottom: 17px;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 1.33;\n}\n\n.Search-Row-Table {\n  align-items: flex-start;\n  font-size: 18px;\n}\n\n.Search-Row-Header,\n.Search-Row-Table {\n  text-align: left;\n\n  @include media-breakpoint-down(lg) {\n    padding-right: 0;\n    padding-left: 0;\n  }\n\n  .col {\n    display: flex;\n    align-items: center;\n  }\n\n  .Col--name,\n  .Col--address {\n    display: block;\n    flex: 1;\n    max-width: initial;\n  }\n\n  .Col--address {\n    @include media-breakpoint-down(sm) {\n      display: none\n    }\n  }\n\n  .Col--name {\n    @include media-breakpoint-down(lg) {\n      padding-left: 0;\n    }\n  }\n\n  .Col--reg {\n    flex: 0 0 140px;\n\n    @include media-breakpoint-down(sm) {\n      flex: 0 0 80px;\n      padding: 0;\n      text-align: center;\n      white-space: normal;\n    }\n  }\n\n  .Col--cta {\n    flex: 0 0 60px;\n    justify-content: flex-end;\n    color: $gbp-blue;\n    font-size: 24px;\n\n    @include media-breakpoint-down(sm) {\n      display: none;\n    }\n  }\n}\n\n.Search-Row-Top {\n  background: $gbp-blue;\n  color: $white;\n\n  @include media-breakpoint-down(lg) {\n    padding-right: 11px;\n    padding-left: 11px;\n  }\n  @include media-breakpoint-down(md) {\n    .Col--cta {\n      display: none;\n    }\n  }\n}\n\n// .ListItemContainer-XS {\n//   &.Last {\n//     display: flex;\n//     justify-content: flex-end;\n//     @media screen and (max-width: 767px) {\n//       justify-content: center;\n//     }\n//   }\n//   @media screen and (max-width: 767px) {\n//     padding: 0.5rem 0 !important ;\n//   }\n// }\n// .ListItemContainer-MainXS {\n//   @media screen and (max-width: 767px) {\n//     margin-bottom: 0.5rem !important;\n//     padding: 0.75rem 0 !important ;\n//   }\n// }\n\n.Pagination-Container {\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 2rem;\n  :nth-child(2) {\n    margin-left: 1rem;\n  }\n  :nth-last-child(2) {\n    margin-right: 1rem;\n  }\n}\n\n.Search-Heading {\n  margin-top: 64px;\n  font-weight: 100;\n  font-size: rem(50px);\n}\n\n\n.Row-Margin {\n  margin: 16px 0 32px;\n  @media screen and (max-width: 800px) {\n    margin: 32px 0 48px;\n  }\n  @media screen and (min-width: 1824px) {\n    margin: 32px 0 48px;\n  }\n}\n\n.Lighter-ColorText {\n  color: $highlight-text-color;\n}\n\n\n.pagination {\n  flex-wrap: wrap;\n\n  li {\n    &.previous,\n    &.next {\n      margin: 10px;\n\n      a {\n        padding: 4px 32px;\n        font-weight: 700;\n        font-size: 24px;\n        line-height: 1.5;\n      }\n\n      @media screen and (max-width: 800px) {\n        width: 100%;\n      }\n    }\n  }\n}\n\n.Pagination-Item {\n  margin: 10px;\n  color: $gbp-blue;\n  font-weight: 700;\n\n  a {\n    &::after {\n      content: \".\"\n    }\n  }\n\n  &.active {\n    color: $gbp-rich-green;\n  }\n\n}\n\n.resultsHeading {\n  margin-top: 80px;\n  // margin: 80px 0 45px;\n  // font-weight: 300;\n  // font-size: 42px;\n  // font-family: $font-family-base;\n  // line-height: 1.14;\n}\n","// Fonts colors\n$primary: #415a77;\n$secondary: #2e2e3a;\n$header-background: #415a77;\n$primary-green: #2afca3;\n$light-grey: #f1f4fb;\n$blue: #317af6;\n$light-blue: #89b8f1;\n$light-green: #8ebbf1;\n$border-light: #d3e1fd;\n$white: #fff;\n$sky-blue: #cad8f2;\n$green: #3cc221;\n$red: #f42b03;\n$golden: #ffe13e;\n$pink: #fd6383;\n$dark-blue: #405873;\n$dark-blue-active: #35485e;\n$pale-grey: #f8fafd;\n$table-border: #c5d5f4;\n$highlight-text-color: #2b2b2b;\n$black: #000000;\n$accent4: #fab723;\n$maroon: #bb0611;\n$dark-blue-link: #263546;\n\n\n$gbp-rich-green: #003825;\n$gbp-electric-green: #00ff7f;\n$gbp-blue: #00a4ff;\n\n$table-border: $gbp-electric-green;\n\n$font-family-base: 'MADETOMMY', Arial, sans-serif;\n$font-family-alt: 'HeadingPro', Arial, sans-serif;\n\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  // xxl: 1440px,\n  // xxxl: 1600px\n);\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  // xxl: 1440px,\n  // xxxl: 1600px\n);\n\n\n$zi-header: 1000;\n$zi-cookie-overlay: 1100;\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @return if($n != null and $n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width. Null for the largest (last) breakpoint.\n// The maximum value is calculated as the minimum of the next one less 0.02px\n// to work around the limitations of `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $next: breakpoint-next($name, $breakpoints);\n  @return if($next, breakpoint-min($next, $breakpoints) - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  $max: breakpoint-max($name, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($name, $breakpoints) {\n      @content;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
